import { Typography } from '@material-ui/core';
import React from 'react';
import { ItemShowProps } from './types';

export const FreeInputShow = ({
  config: { free_input = [] } = {},
}: ItemShowProps) => (
  <>
    {free_input.map((freeInputValue: string) => (
      <Typography variant="subtitle2">
        {'\u00A0\u00A0- '}
        {freeInputValue}
      </Typography>
    ))}
  </>
);
